import React from 'react';

export interface SignMin2IconProps {}

export const SignMin2Icon: React.FC<SignMin2IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1264 14.7815C11.2185 15.0418 11.0821 15.3275 10.8217 15.4195C10.6531 15.4791 10.4655 15.4441 10.3297 15.3278L3.5 9.47406L10.3297 3.62037C10.5393 3.44067 10.855 3.46496 11.0347 3.67462C11.1511 3.81042 11.1861 3.99805 11.1264 4.16668L9.7705 8H11.5C15.0386 8 17.9167 10.8276 17.9982 14.3466L18 14.5V21H15V14.5C15 12.6073 13.4976 11.0655 11.6203 11.002L11.5 11H9.789L11.1264 14.7815Z"
        fill="#192033"
      />
    </svg>
  );
};
